"use client";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { progressAtom } from "@/hooks/headerHooks";

export default function ProgressBar() {
  const [progress] = useAtom(progressAtom);
  const [width, setWidth] = useState(0);
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (progress) {
      setOpacity(1);
      // Start at some width
      setWidth((w) => (w === 0 ? 10 : w));
      // Trickle
      timer = setInterval(() => {
        setWidth((prev) => {
          if (prev >= 90) return prev;
          const diff = Math.random() * 10;
          return prev + diff;
        });
      }, 500);
    } else {
      // Complete
      if (width > 0 || opacity > 0) {
        setWidth(100);
        const fadeOut = setTimeout(() => {
          setOpacity(0);
          setTimeout(() => setWidth(0), 300); // Reset after fade out
        }, 300);
        return () => clearTimeout(fadeOut);
      }
    }
    return () => clearInterval(timer);
  }, [progress, width, opacity]);

  return (
    <div
      className="custom-progress-bar"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        height: "3px",
        width: `${width}%`,
        opacity: opacity,
        transition: "width 300ms ease-out, opacity 300ms ease-out",
        zIndex: 99999,
      }}
    />
  );
}
